import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { CreateOrEditCapacityModel } from "../../../models/tables/create-or-edit-capacity.model";
import { ChooseCapacityTypeDialogComponent } from "../choose-capacity-type-dialog/choose-capacity-type-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { CreateCapacityForVenuesComponent } from "../create-capacity-for-venues/create-capacity-for-venues.component";

@Component({
  selector: 'app-continue-or-create-new-capacity-dialog',
  templateUrl: './continue-or-create-new-capacity-dialog.component.html',
  styleUrls: ['./continue-or-create-new-capacity-dialog.component.scss']
})
export class ContinueOrCreateNewCapacityDialogComponent implements OnInit {

  //#region Fields
  public capacityConfig: CreateOrEditCapacityModel;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private dialogService: DialogService,
    private translate: TranslateService
  ) {
    if (this.config.data != undefined && this.config.data.capacityConfig) {
      this.capacityConfig = this.config.data.capacityConfig;
    }
  }

  ngOnInit(): void {
  }

  //#endregion

  //#region Public Methods
  public createNew(): void {
    const ref = this.dialogService.open(ChooseCapacityTypeDialogComponent, {
      data: {
        fromAddVenue: true
      },
      header: this.translate.instant('VENUE.CREATE_CAPACITY'),
      width: '335px'
    });
    ref.onClose.subscribe((item: any) => {
      this.ref.close(item);
    });
  }

  public continue(): void {
    const ref = this.dialogService.open(CreateCapacityForVenuesComponent, {
      data: {
        capacityConfig: this.capacityConfig,
        fromAddVenue: true
      },
      width: '1000px',
      styleClass: '',
      header: this.capacityConfig.name ? this.capacityConfig.name : 'Default capacity'
    });
    ref.onClose.subscribe((item: any) => {
      this.ref.close(item);
    });
  }
  //#endregion
}
